import Catalyst from '@Services/Catalyst';

export const trackViewMore = (context, title, type) => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: `rx2:results:${context}:${title}:${type}:view more`, // evar124 = rx2:results:substances:commercial suppliers:popup:view more
  });
};

export const trackFilterByValue = (context, title) => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: `rx2:results:${context}:${title}:filter by value`,
  });
};

export const trackRedirectToPreferences = () => {
  Catalyst.trackEvent('navigationClick', {
    link: {
      location: 'rx2:results:substances:filters:supplier preferences:',
      name: 'edit preferences',
    },
  });
};
